



















import { Component, Prop, Vue } from "vue-property-decorator";
import TextLink from "../TextLink.vue";

@Component({
  components: {
    TextLink,
  },
})
export default class Footer extends Vue {}
